<div class="absence-form">
  <div class="row">
    <div class="col">
      <h2>{{ 'CreateAbsence' | translate }}</h2>
    </div>
  </div>

  <div class="row approval-progress-row">
    <div class="col">
      <app-approval-progress [statusId]="absenceStatusId" [finalMeta]="finalDecisionMeta"
      [intermediateSteps]="intermediateSteps"></app-approval-progress>
    </div>
  </div>

  <form [formGroup]="absenceForm">
    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'AbsenceType' | translate }}</mat-label>
          <mat-select formControlName="absenceTypeId" required>
            @for (absenceType of absenceTypes$ | async; track absenceType) {
              <mat-option [value]="absenceType.Id">
                {{ absenceType.Name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'AbsenceSubtype' | translate }}</mat-label>
          <mat-select formControlName="absenceSubtypeId" required>
            @for (absenceSubtype of absenceSubtypes$ | async; track absenceSubtype) {
              <mat-option [value]="absenceSubtype.Id">
                {{ absenceSubtype.Name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    @if (isWorkerFamilyMemberRequired$ | async) {
      <div class="row">
        <div class="col">
          <app-absence-form-family-members-picker [workerId]="data.WorkerId" [isEnabled]="canEditAbsenceForm$ | async"
            [requiredFileTypes]="requiredFileTypes$ | async"
            [alreadySavedFamilyMembersFiles]="data.Absence?.FamilyMembersFiles || []"
          (onFamilyMembersChange)="onFamilyMembersChange($event)"></app-absence-form-family-members-picker>
        </div>
      </div>
    }

    @if (isFamilyMemberCare() || isHouseholdMemberCare()) {
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'PersonToCareFullName' | translate }}</mat-label>
            <input matInput placeholder="{{ 'PersonToCareFullName' | translate }}" formControlName="personToCareFullName"
              maxlength="100" />
            </mat-form-field>
          </div>
        </div>
      }

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'AbsencePeriod' | translate }}</mat-label>
            <mat-date-range-input [rangePicker]="picker" [dateFilter]="dateFilter">
              <input matStartDate formControlName="startDate" [placeholder]="'StartDate' | translate" />
              <input matEndDate formControlName="endDate" [placeholder]="'EndDate' | translate" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker (closed)="calendarClosed()" (opened)="calendarOpened($event)"
              [maxRange]="absenceDateRange$ | async" [areWeekendsDaysOff]="areWeekendsDaysOff$ | async"
              [daysOff]="daysOff$ | async" [absenceLimitCalcType]="absenceLimitCalcType$ | async"
            panelClass="with-tooltip" #picker></mat-date-range-picker>
          </mat-form-field>

          @if (absenceForm?.hasError('maxDateRangeExceeded')) {
            <alert message="AbsenceMaxDateRangeExceeded"
            alertType="error"></alert>
          }
        </div>
      </div>

      @if (absenceSubtype?.RequireLeaveSubstitution) {
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'SubstituteWorker' | translate }}</mat-label>
              <input matInput formControlName="substituteWorker" placeholder="{{ 'SubstituteWorker' | translate }}"
                [matAutocomplete]="autocompleteSubstituteWorker" />
                <mat-autocomplete #autocompleteSubstituteWorker="matAutocomplete" [displayWith]="displayValue">
                  @for (substituteWorker of substituteWorkers$ | async; track substituteWorker) {
                    <mat-option [value]="substituteWorker">
                      {{ substituteWorker.FullName }}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
        }

        @if (mayBeHourly$ | async) {
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'AbsenceStartTime' | translate }}</mat-label>
                <input type="time" matInput formControlName="startTime" name="startTime" />
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'AbsenceEndTime' | translate }}</mat-label>
                <input type="time" matInput formControlName="endTime" name="endTime" />
              </mat-form-field>
            </div>
          </div>
        }

        @if (absenceForm?.hasError('maxTimeRangeExceeded')) {
          <alert message="AbsenceMaxTimeRangeExceeded"
          alertType="error"></alert>
        }

        @if (isFamilyMemberCare()) {
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'KinshipDegree' | translate }}</mat-label>
                <mat-select formControlName="absenceLeaveCareKinshipDegreeId" required>
                  @for (kinship of absenceLeaveCareKinshipDegrees$ | async; track kinship) {
                    <mat-option [value]="kinship.Id">
                      {{ kinship.Name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        }

        @if (isHouseholdMemberCare()) {
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'PersonToCareAddress' | translate }}</mat-label>
                <textarea matInput formControlName="personToCareAddress" placeholder="{{ 'PersonToCareAddress' | translate }}"
                maxlength="300"></textarea>
              </mat-form-field>
            </div>
          </div>
        }

        @if (!(isFamilyMemberCare() || isHouseholdMemberCare())) {
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'AbsenceReason' | translate }}</mat-label>
                <textarea matInput formControlName="absenceReason" placeholder="{{ 'AbsenceReason' | translate }}"
                maxlength="250"></textarea>
              </mat-form-field>
            </div>
          </div>
        }

        @if (isFamilyMemberCare() || isHouseholdMemberCare()) {
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'ReasonToCare' | translate }}</mat-label>
                <textarea matInput formControlName="reasonToCare" placeholder="{{ 'ReasonToCare' | translate }}"
                maxlength="300"></textarea>
              </mat-form-field>
            </div>
          </div>
        }

        @if (!(isWorkerFamilyMemberRequired$ | async)) {
          <app-absence-form-file-upload
            [requiredFileTypes]="requiredFileTypes$ | async" [alreadySavedFiles]="data.Absence?.Files || []"
          (afterFileUpload)="afterFileUpload($event)"></app-absence-form-file-upload>
        }

        <alert
          [message]="isConfirmAbsenceButtonVisible() ? 'CreateConfirmableAbsenceInfoMessage' : 'CreateApprovableAbsenceInfoMessage'"
        alertType="info"></alert>

        <div class="row">
          <div class="col">
            <button mat-raised-button class="mr-1" color="accent" (click)="close()">{{ 'Close' | translate }}</button>
            @if (isBackToDraftButtonVisible()) {
              <button mat-raised-button class="mr-1 float-right" color="primary"
                [visibleWithPermissions]="['BackToDraftMyAbsences', 'BackToDraftWorkerAbsences']"
                (click)="backToDraftAbsence()">
                {{ 'BackToDraftAbsence' | translate }}
              </button>
            }
            @if (isSubmitDraftButtonVisible()) {
              <button mat-raised-button class="mr-1 float-right" color="primary"
                (click)="submitDraft()">
                {{ 'SaveAsDraft' | translate }}
              </button>
            }
            @if (isSendToApprovalButtonVisible()) {
              <button mat-raised-button class="mr-1 float-right" color="primary"
                (click)="sendToApproval()">
                {{ 'SendToApproval' | translate }}
              </button>
            }
            @if (isConfirmAbsenceButtonVisible()) {
              <button mat-raised-button class="mr-1 float-right" color="primary"
                (click)="confirmAbsence()">
                {{ 'ConfirmAbsence' | translate }}
              </button>
            }
            @if (approvingButtonsVisible) {
              @if (isRejectAbsenceButtonVisible()) {
                <button mat-raised-button class="mr-1 float-right" color="error"
                  [visibleWithPermissions]="['RejectWorkerAbsences', 'Supervisor']"
                  (click)="rejectAbsence()">
                  {{ 'RejectAbsence' | translate }}
                </button>
              }
              @if (isAcceptAbsenceButtonVisible()) {
                <button mat-raised-button class="mr-1 float-right" color="success"
                  [visibleWithPermissions]="['AcceptWorkerAbsences', 'Supervisor']"
                  (click)="acceptAbsence()">
                  {{ 'AcceptAbsence' | translate }}
                </button>
              }
            }
            @if (isCancelAbsenceButtonVisible()) {
              <button mat-raised-button class="mr-1 float-right" color="primary"
                [visibleWithPermissions]="['CancelMyWorkersAbsences', 'CancelGlobalWorkersAbsences', 'Supervisor']"
                (click)="cancelAbsence()">
                {{ 'CancelAbsence' | translate }}
              </button>
            }
            @if (isSaveAbsenceFilesButtonVisible()) {
              <button mat-raised-button class="mr-1 float-right" color="primary"
                [disabled]="isSaveAbsenceFilesButtonDisable()" (click)="saveAbsenceFiles()">
                {{ 'SaveAbsenceFiles' | translate }}
              </button>
            }
          </div>
        </div>
      </form>
    </div>